/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/11/2021
 */
import mergeProps from "@/router/utils/mergeProps";
let EmptyRouterView = () => import(/* webpackChunkName: "ClientsModule" */ '@/core/components/EmptyRouterView.vue')
import memberDetailsRoutes from "@/router/recoveryCoaching/team/memberDetailsRoutes.js";
let TeamListMainPage = () => import(/* webpackChunkName: "TeamManagement" */  "@/core/modules/coach/Profile/Team/TeamListMainPage.vue");

export default [

	{
		path: 'team',
		component: EmptyRouterView,
		props: mergeProps,
		children: [

			{
				path: '',
				name: 'TeamListMainRoute',
				component: TeamListMainPage,
				props: mergeProps,
				children:[
				]
			},
			...memberDetailsRoutes,

		]
	},




]

